module.exports = __webpack_public_path__ + "static/img/down.8c6881e9.svg";